module.exports = __webpack_public_path__ + "media/images/logo-f0c0cc101bd0dbb902e9b3e6ffa3dd2c.png";